@file:OptIn(InternalResourceApi::class)

package waifupics.modules.core.theme.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/waifupics.modules.core.theme.generated.resources/"

@delegate:ResourceContentHash(-1_571_806_907)
internal val Res.font.rubik: FontResource by lazy {
      FontResource("font:rubik", setOf(
        ResourceItem(setOf(), "${MD}font/rubik.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(642_972_712)
internal val Res.font.rubik_black: FontResource by lazy {
      FontResource("font:rubik_black", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_black.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_815_124_424)
internal val Res.font.rubik_bold: FontResource by lazy {
      FontResource("font:rubik_bold", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_298_616_421)
internal val Res.font.rubik_bold_italic: FontResource by lazy {
      FontResource("font:rubik_bold_italic", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_bold_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(472_822_109)
internal val Res.font.rubik_extra_bold: FontResource by lazy {
      FontResource("font:rubik_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_extra_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_384_448_470)
internal val Res.font.rubik_extra_bold_italic: FontResource by lazy {
      FontResource("font:rubik_extra_bold_italic", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_extra_bold_italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_899_908_981)
internal val Res.font.rubik_light: FontResource by lazy {
      FontResource("font:rubik_light", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-969_952_012)
internal val Res.font.rubik_medium: FontResource by lazy {
      FontResource("font:rubik_medium", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_005_649_689)
internal val Res.font.rubik_regular: FontResource by lazy {
      FontResource("font:rubik_regular", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(704_478_557)
internal val Res.font.rubik_semi_bold: FontResource by lazy {
      FontResource("font:rubik_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/rubik_semi_bold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("rubik", Res.font.rubik)
  map.put("rubik_black", Res.font.rubik_black)
  map.put("rubik_bold", Res.font.rubik_bold)
  map.put("rubik_bold_italic", Res.font.rubik_bold_italic)
  map.put("rubik_extra_bold", Res.font.rubik_extra_bold)
  map.put("rubik_extra_bold_italic", Res.font.rubik_extra_bold_italic)
  map.put("rubik_light", Res.font.rubik_light)
  map.put("rubik_medium", Res.font.rubik_medium)
  map.put("rubik_regular", Res.font.rubik_regular)
  map.put("rubik_semi_bold", Res.font.rubik_semi_bold)
}
